export enum Endpoints {
  models_post = "/api/v1/models",
  exercises_get_id = "/api/v1/studentui/exercises/",
  exercises_post = "/api/v1/authorui/submissions/",
  exercises_post_id = "/authorui/exercises",
  submissionexercises_get_assessments = "/api/v1/studentui/submissionexercises/",
}
